




























































































































































































































import { listFactory, ListLoadBehavior } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import PartnerSelect from './components/Select.vue';
import { store } from './store/list';
import { NAME } from './constants';
import { listMutations } from './store/types';
import { showAlert } from '@/main/utils/notifications';
import { apiProvider } from '@/modules/kartoteka/partner/api';
import { VIN_LAST_SIX_CHARS } from './constants';
import { SEARCHINCDB_CUSTOMERSCREEN } from './constants';
import { DUMMY_CUSTOMERID } from './constants';
import { ScreenSize } from '@/main/components/constants';
import { splitValidationCheck } from '../../servis/zakazka/utils';
export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect,
	},
	
	mounted(){
		var element = document.getElementsByClassName("el-main");
					if(element.length!=0)
						element[0].classList.remove('d-flex');
	},
	computed: {
		mutationsMappers() {
			return {
				jinyPlatce: `${this.storeUri}/${listMutations.PARTNER_JINY_PLATCE_FILTER_SELECT_MAPPER}`,
			};
		},
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
	},
	data() {
		return {
			showCustomerSelectionDialog : false,
			customerSelectionDialogHeaderText: 'Customer Details',
			customerSelectionTable:[],
			tableKey: '0',
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			vehicleValidationStatus: false,
			isCustomerAlreadyExist: true,
		};
	},
	methods: {
		//Customer Type Individual and Corporate Commented code kept
		// onCreateFyzickaOsobaClick() {
		// 	openEdit(NAME, PageMode.CREATE, {
		// 		props: true,
		// 		filter: {
		// 			...this.filter,
		// 			PartnertypPzn: 1,
		// 		},
		// 	});
		// },
		// onCreateInstituceClick() {
		// 	openEdit(NAME, PageMode.CREATE, {
		// 		props: true,
		// 		filter: {
		// 			...this.filter,
		// 			PartnertypPzn: 2,
		// 		},
		// 	});
		// },
		async zakaznikCDB() {
			if(!this.SearchString || !this.VIN || !this.LicensePlate){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForMandatoryFields'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			if(this.VIN && this.VIN !== undefined){
				if(this.VIN.length < VIN_LAST_SIX_CHARS){
					showAlert({
						message: this.LocalizeChyboveHlasky('AlertMsgForInvalidVINLength'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}
			}
			this.SearchString = this.SearchString.replace(/\s/g, "");
			this.LicensePlate = this.LicensePlate.replace(/\s/g, "");
			this.startLoading();
			const { data: customerDetails } = await apiProvider.getCustomerFromCdb(this.SearchString, this.VIN, this.LicensePlate);
			this.endLoading();			
			if(customerDetails?.length>1) {
				this.showCustomerSelectionDialog=true;
				this.customerSelectionTable=customerDetails;
			} 
			else if(customerDetails?.length==1) {
                await this.validateVehicleDetails(customerDetails[0].VIN, customerDetails[0].GoldenAccountId);
					//route to create page
					if(this.vehicleValidationStatus === true){
						this.showCustomerSelectionDialog=false;
						return;
					}
					if(this.isCustomerAlreadyExist == false){		
					openEdit(NAME, PageMode.CREATE, {
							props: true,
							goldenAccountId: customerDetails[0].GoldenAccountId,
							salutation: customerDetails[0].Salutation,
							name: customerDetails[0].Name,
							dmsPhone: customerDetails[0].DmsPhone,
							dmsMobile: customerDetails[0].DmsMobile,
							dmsEmail:customerDetails[0].DmsEmail,
							vin: customerDetails[0].VIN,
							accountRecordType: customerDetails[0].AccountRecordType,
							dmsFax: customerDetails[0].DmsFax,
							goldenAssetName: customerDetails[0].GoldenAssetName,
							billingStreet: customerDetails[0].BillingStreet,
							postalCode: customerDetails[0].PostalCode,
							billingCity: customerDetails[0].BillingCity,
							billingCountry: customerDetails[0].BillingCountry,
							birthDate: customerDetails[0].BirthDate,
							insuranceType: customerDetails[0].InsuranceType,
							insurance: customerDetails[0].Insurance,
							gender: customerDetails[0].Gender,
							registrationPlate: customerDetails[0].RegistrationPlate
							,customerInsertSource : SEARCHINCDB_CUSTOMERSCREEN,
							contactDetails: customerDetails[0].ContactDetails,
							goldenAccountLastModified: customerDetails[0].GoldenAccountLastModified,
					});
				}
			}
			else {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AlertMsgForNoRecordsFound') });
			}
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		async onCustomerRowSelect(event: Event, row: any) {
			await this.validateVehicleDetails(row.VIN, row.GoldenAccountId);
			if(this.vehicleValidationStatus === true){
				this.showCustomerSelectionDialog=false;
				return;
			}
            if (row && this.isCustomerAlreadyExist == false) {
					openEdit(NAME, PageMode.CREATE, {
							props: true,
							goldenAccountId: row.GoldenAccountId,
							salutation: row.Salutation,
							name: row.Name,
							dmsPhone: row.DmsPhone,
							dmsMobile: row.DmsMobile,
							dmsEmail: row.DmsEmail,
							vin: row.VIN,
							accountRecordType: row.AccountRecordType,
							dmsFax: row.DmsFax,
							goldenAssetName: row.GoldenAssetName,
							billingStreet:row.BillingStreet,
							postalCode:row.PostalCode,
							billingCity:row.BillingCity,
							billingCountry: row.BillingCountry,
							birthDate: row.BirthDate,
							insuranceType: row.InsuranceType,
							insurance: row.Insurance,
							gender: row.Gender,
							registrationPlate:row.RegistrationPlate
							,customerInsertSource : SEARCHINCDB_CUSTOMERSCREEN,
							contactDetails: row.ContactDetails,
							goldenAccountLastModified: row.GoldenAccountLastModified
					});
			}
			this.showCustomerSelectionDialog=false;
		},
		async validateVehicleDetails(vin : string, goldenAccountId : string){
			this.startLoading();
			const { data: response } = await apiProvider.getVehicleDetailsByVIN(vin, goldenAccountId);
			this.endLoading();
			if(!response){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForVINNotFound'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			if(response.IsInValidVINData){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForInvalidVINData'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			if(response.IsVINFoundInServiceOrder){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForVINFoundInActiveServiceOrder').replace(/#VIN#/g, (m : string) => {
						if(m === '#VIN#')
							return response.KaroserieNr;
						return "";
					}),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				this.vehicleValidationStatus = true;
				return;
			}
            if (response?.IsVINAndGoldenAccountCombinationExist) {
				this.isCustomerAlreadyExist = true;
				showAlert({
					message: this.LocalizeChyboveHlasky('CUSTOMER_PRESENT_IN_DEALER'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
					return;
			}
			else
					this.isCustomerAlreadyExist = false;
					return;
		},
	},
});
